﻿import ko from 'knockout';
import $ from 'jquery';
import { DateField } from "../datefield"
import { SuggestSearch } from '../suggestsearch';

export default class Utility {
  public static excludeKeys = ['editorTableInternalId', 'toJSON', 'tableKey', 'emptyObjectBuilder'];
  static formatTextIfNumber(value): string {
    if ($.isNumeric(value))
      return Number(value).toLocaleString('en', { style: 'decimal', currency: 'USD', maximumFractionDigits: 2, minimumFractionDigits: 2 });
    else
      return value;
  }

  static relativeName(name: string): string {
    return name.substring(name.lastIndexOf(".") + 1, name.length);
  }

  static formatMoney(value) {
    if (typeof value != "string")
      return value;
    var money = value.replace("(", "-").replace(")", "");
    if (value.substring(0, 1) === "$")
      money = value.substring(1, value.length);
    return money;
  }

  static guid() {
    function s4() {
      return Math.floor((1 + Math.random()) * 0x10000)
        .toString(16)
        .substring(1);
    }
    return s4() + s4() + '-' + s4() + '-' + s4() + '-' +
      s4() + '-' + s4() + s4() + s4();
  }
  static isBlankItem(item): boolean {
    var isBlank = true;
    Object.keys(item).forEach(k => {
      if (this.excludeKeys.indexOf(k) != -1)
        return;
      var unwrappedValue = ko.utils.unwrapObservable(item[k]);
      if (unwrappedValue === 0 || unwrappedValue)
        isBlank = false;
    });
    return isBlank;
  }

  static addRow(data, numRowsToAdd, focusOnNewRow) {
    if (!numRowsToAdd)
      numRowsToAdd = 1;

    var currentRowCount = data.Rows().length;

    for (var i = 0; i < numRowsToAdd; i++) {
      var emptyObject = { editorTableInternalId: Utility.guid() };
      Object.keys(data.emptyObjectBuilder).forEach((key) => {
        var value = data.emptyObjectBuilder[key];
        emptyObject[value.name] = value.build(emptyObject);
      });
      data.Rows.push(emptyObject);
    }
    setTimeout(() => { //wait for the new DOM row to show up
      var $table = $("[data-et-key='" + data.tableKey + "']");

      $table.find("tbody tr").each((index, el) => {
        if (index < currentRowCount)
          return;
        var $element: any = $(el);
        //todo bzink - remove this hack
        $element.find(DateField.wireup).each((i, e) => {
          var $el: any = $(e);
          $el.datefield();
        });
        $element.find(SuggestSearch.wireup).each((i, e) => {
          var $el: any = $(e);
          $el.suggestsearch();
        });
        $element.find(":input[type='text'], :input[type='checkbox'], select").each((i, e) => {
          var cellId = $(e).attr("id");
          if (cellId) {
            cellId = cellId.replace(/_[0-9]+$/, '');
            $(e).attr("id", cellId + "_" + index);
          }
        })
      });

      if (focusOnNewRow) {
        $table.find("tbody tr").eq(currentRowCount)
          .find(":input[type='text'], :input[type='checkbox'], select").first().focus();
      }
    }, 200);
  }
}
